export enum AffinityFilterType {
  LEFT = 'left',
  RIGHT = 'right',
  TRANSACTION = 'transaction'
}
